export const TRANSMISSION_LIST = [
  { value: '..S', label: '..S' },
  { value: '4F', label: '4F' },
  { value: '4FAT', label: '4FAT' },
  { value: '4wd', label: '4wd' },
  { value: '5', label: '5' },
  { value: '5C', label: '5C' },
  { value: '5D', label: '5D' },
  { value: '5F', label: '5F' },
  { value: '5FMT', label: '5FMT' },
  { value: '5I', label: '5I' },
  { value: '5MT', label: '5MT' },
  { value: '6', label: '6' },
  { value: '6F', label: '6F' },
  { value: '6HL', label: '6HL' },
  { value: '6I', label: '6I' },
  { value: '6MT', label: '6MT' },
  { value: '6X2', label: '6X2' },
  { value: '7F', label: '7F' },
  { value: '7FAT', label: '7FAT' },
  { value: '7MT', label: '7MT' },
  { value: 'A/T', label: 'A/T' },
  { value: 'AT', label: 'AT' },
  { value: 'Automatic', label: 'Automatic' },
  { value: 'C0AT', label: 'C0AT' },
  { value: 'C4', label: 'C4' },
  { value: 'C5', label: 'C5' },
  { value: 'CA', label: 'CA' },
  { value: 'CAT', label: 'CAT' },
  { value: 'CCVT', label: 'CCVT' },
  { value: 'Column MT', label: 'Column MT' },
  { value: 'CVT', label: 'CVT' },
  { value: 'D5', label: 'D5' },
  { value: 'DA', label: 'DA' },
  { value: 'DAT', label: 'DAT' },
  { value: 'DBA-GJEFP', label: 'DBA-GJEFP' },
  { value: 'DBA-NT31', label: 'DBA-NT31' },
  { value: 'DBE-NCP165V', label: 'DBE-NCP165V' },
  { value: 'DCVT', label: 'DCVT' },
  { value: 'F0AT', label: 'F0AT' },
  { value: 'F4', label: 'F4' },
  { value: 'F4AT', label: 'F4AT' },
  { value: 'F5', label: 'F5' },
  { value: 'F5AT', label: 'F5AT' },
  { value: 'F5MT', label: 'F5MT' },
  { value: 'F6', label: 'F6' },
  { value: 'F6AT', label: 'F6AT' },
  { value: 'F7', label: 'F7' },
  { value: 'F7AT', label: 'F7AT' },
  { value: 'F8AT', label: 'F8AT' },
  { value: 'FA', label: 'FA' },
  { value: 'FA6', label: 'FA6' },
  { value: 'Fast', label: 'Fast' },
  { value: 'FAT', label: 'FAT' },
  { value: 'FCV', label: 'FCV' },
  { value: 'FCVT', label: 'FCVT' },
  { value: 'Floor AT', label: 'Floor AT' },
  { value: 'Floor MT', label: 'Floor MT' },
  { value: 'FMT', label: 'FMT' },
  { value: 'GC-KM70', label: 'GC-KM70' },
  { value: 'GC-SK82TN', label: 'GC-SK82TN' },
  { value: 'I5', label: 'I5' },
  { value: 'I6', label: 'I6' },
  { value: 'IA', label: 'IA' },
  { value: 'IAT', label: 'IAT' },
  { value: 'ICVT', label: 'ICVT' },
  { value: 'Instrument panel MT', label: 'Instrument panel MT' },
  { value: 'M6', label: 'M6' },
  { value: 'Manual', label: 'Manual' },
  { value: 'Manual Transmission', label: 'Manual Transmission' },
  { value: 'MT', label: 'MT' },
  { value: 'MT/AT', label: 'MT/AT' },
  { value: 'MT5', label: 'MT5' },
  { value: 'MT6', label: 'MT6' },
  { value: 'P5', label: 'P5' },
  { value: 'PAT', label: 'PAT' },
  { value: 'Smoother', label: 'Smoother' },
];
